module.exports = __webpack_public_path__ + "img/2017-4.ea4fbb7d.jpg";